import React from 'react'
import {observer, inject} from 'mobx-react';
import {
    Card,
    CircularProgress, Container
} from "@material-ui/core";
import {CabinetBookingElement} from "./history/element";
import {BookingHeader} from "../shared/header";
import {UserStatsElement} from "./user_stats";
import {CabinetBannerElement} from "./banner";
import {CabinetPushElement} from "./push";
import {BookingCancelConfirmDialog} from "./history/booking-cancel-confirm-dialog";
import {SnackBarAlert} from "../shared/snackbar";

const UserCabinetIndexPage = inject('cabinetMainPageStore')(observer(({cabinetMainPageStore}) => {
        cabinetMainPageStore.load();
        return (
            <Container className="cabinet-main-page">
                {cabinetMainPageStore.loading && !cabinetMainPageStore.showSpinner ?
                    <div className="fullscreen-load-bar ">
                        <CircularProgress color="secondary" className="loader"/>
                    </div>
                    : ''
                }
                {
                    cabinetMainPageStore.showSpinner ?
                        <CircularProgress color="secondary" className="loader"/> :
                        <div>
                            <BookingHeader buttonText={'Выйти'}
                                           buttonCallback={cabinetMainPageStore.logout}/>
                            <div className="cabinet-main-block">
                                <div className="left-block">
                                    <UserStatsElement user={cabinetMainPageStore.user}
                                                      stats={cabinetMainPageStore.stats}
                                                      history={cabinetMainPageStore.history}/>
                                    {cabinetMainPageStore.push ?
                                        <CabinetPushElement push={cabinetMainPageStore.push}/> : ''}
                                    {cabinetMainPageStore.banner ?
                                        <CabinetBannerElement banner={cabinetMainPageStore.banner}/> : ''}
                                </div>
                                <div className="right-block">
                                    <Card className="orders-list">
                                        <div className="orders-list-group">
                                            <div className="orders-block-title">Ваши заказы</div>
                                            {
                                                cabinetMainPageStore.accepted_orders.length > 0 ?
                                                    cabinetMainPageStore.accepted_orders.map((el, key) =>
                                                        <CabinetBookingElement
                                                            key={key}
                                                            cancelOrderClickCallback={cabinetMainPageStore.cancelOrderClick}
                                                            booking={el}
                                                            type='accepted'/>) :
                                                    <div className="empty-orders-list">У вас нет активных
                                                        заказов</div>
                                            }
                                            <BookingCancelConfirmDialog
                                                open={cabinetMainPageStore.show_cancel_dialog}
                                                handleCancel={() => cabinetMainPageStore.show_cancel_dialog = false}
                                                handleOk={cabinetMainPageStore.cancelOrderCallback}
                                            />
                                        </div>
                                        {
                                            cabinetMainPageStore.waiting_orders.length > 0 ?
                                                <div className="orders-list-group">
                                                    <div className="orders-block-title waiting-orders">Ждет
                                                        подтверждения
                                                        студии
                                                    </div>
                                                    {cabinetMainPageStore.waiting_orders.map((el, key) =>
                                                        <CabinetBookingElement
                                                            key={key}
                                                            booking={el}
                                                            type='waiting'/>)}
                                                </div>
                                                : ''
                                        }
                                    </Card>
                                    {
                                        cabinetMainPageStore.history_orders.length > 0 ?
                                            <Card className="orders-list">
                                                <div className="orders-list-group">
                                                    <div className="orders-block-title">Прошедшие заказы</div>
                                                    {cabinetMainPageStore.history_orders.map((el, key) =>
                                                        <CabinetBookingElement
                                                            key={key}
                                                            booking={el}
                                                            type='last'/>)}
                                                    {!cabinetMainPageStore.history_is_last ?
                                                        <div className='load-more'>
                                                            {cabinetMainPageStore.history_loading ?
                                                                <CircularProgress color="secondary"
                                                                                  className="loader"/> :
                                                                <span
                                                                    onClick={cabinetMainPageStore.paginate.bind(this, 'history')}>
                                                                См.еще
                                                            </span>
                                                            }
                                                        </div> : ''}
                                                </div>
                                            </Card>
                                            : ''
                                    }
                                </div>
                            </div>
                        </div>
                }

                <SnackBarAlert
                    open={cabinetMainPageStore.openAlert}
                    handleClose={() => cabinetMainPageStore.openAlert = false}
                    message={cabinetMainPageStore.alertMessage}
                    messageType={cabinetMainPageStore.alertMessageType}
                />
            </Container>
        );
    }
));

export default UserCabinetIndexPage
